export default __webpack_public_path__ + "static/media/retro.c40c4994.webp";